import { Box, Button, Container, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    Link,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";
import CustomYupTest from "../../CustomYup/CustomYupTest";
import { getIsHideSearchPageRoles, isNotEmpty } from "../../Utils";
import eform_icon from "../../images/eform.jpg";
import enquiry_icon from "../../images/enquiry.jpg";
import { setToken } from "../../redux/action";
import { getUserRole } from "../../redux/selector";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";
import "./LoggedInNav.scss";
import "./LoginPage.scss";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    buttons: {
        textDecoration: "none",
    },
    buttonContainerMobile: {
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
        margin: "auto",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
        width: "60%",
        margin: "auto",
    },
    label: {
        flexDirection: "column",
        fontSize: "15px",
    },
    buttonColor: {
        backgroundColor: "white",
        color: "black",
        // height: "150px",
        width: "150px",
        marginBottom: "25px",
        "&:hover": {
            backgroundColor: "#F39C12",
            color: "white",
        },
    },
});

function Main() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const [cookies, setCookie] = useCookies(["token"]);
    const { token } = useParams();
    const role = useSelector(getUserRole());
    const { emailTest } = CustomYupTest();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const loggedIn = isNotEmpty(cookies?.token);
    let redirect = localStorage.getItem("login_redirect");
    if(!redirect && loggedIn){
        redirect = searchParams.get("redirect");
    }

    if (redirect && redirect != "" && redirect != "null") {
        navigate(redirect.replace("/eformss", ""));
    }

    useEffect(() => {
        //console.log("useEffect", token);
        if (isNotEmpty(token)) {
            dispatch(setToken({ token: token }));
            setCookie("token", token, {
                path: `${Config.CONTENT_PATH}`,
                maxAge: 3600,
                secure: true,
            });
        }
    }, [token]);
    
    // const [open, setOpen] = useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     if (errors?.email == null) {
    //         setOpen(false);
    //     }
    // };

    // const profile = useSelector(getProfile());
    // console.log(profile.email);

    // let yupSchema = yup.object().shape({
    //     email: yup
    //         .string()
    //         .required(t("errorMsg.required"))
    //         .test(...emailTest)
    //         .max(255, t("errorMsg.maxTextLength", { max: 255 })),
    // });

    // const { register, handleSubmit, control, formState, reset, watch } =
    //     useForm({
    //         mode: "onBlur",
    //         resolver: yupResolver(yupSchema),
    //     });
    // const errors = formState.errors;


    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.portal.Home")}
                className="header"
            ></Header>
            
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main className="main">
                    <Box id="main-content" className="active"></Box>
                    <Box
                        className={
                            matches
                                ? classes.buttonContainer
                                : classes.buttonContainerMobile
                        }
                    >
                        {!getIsHideSearchPageRoles(role) &&
                            role !== "SA" &&
                            role !== "E" &&
                            role !== "FO" &&
                            role !== "FR" && (
                                <Button
                                    classes={{
                                        root: classes.buttonColor,
                                        label: classes.label,
                                    }}
                                    className="buttons"
                                    component={Link}
                                    to="/select"
                                    variant="contained"
                                    color="primary"
                                >
                                    <img
                                        src={eform_icon}
                                        alt=""
                                        style={{ height: "100px" }}
                                    />
                                    {t("common.sideNavList.formSelect")}
                                </Button>
                            )}
                        {!getIsHideSearchPageRoles(role) && (
                            <>
                                <br />
                                <br />
                                <Button
                                    classes={{
                                        root: classes.buttonColor,
                                        label: classes.label,
                                    }}
                                    className="buttons"
                                    component={Link}
                                    to="/FormEnquiry"
                                    variant="contained"
                                    color="primary"
                                >
                                    <img
                                        src={enquiry_icon}
                                        alt=""
                                        style={{ height: "100px" }}
                                    />
                                    {t("common.sideNavList.formEnquiry")}
                                </Button>
                            </>
                        )}
                    </Box>
                </main>
            </Box>
        </Container>
    );
}
export default Main;
